/**
 * TODO replace with real club page path when available https://westwing.jira.com/browse/CLUBSTYLE-1680
 */
export default (): boolean => window?.location?.pathname.indexOf('/c/') === 0;
